import React, { useEffect, useState } from 'react'
import "./newpage.css"
import { Link, useParams } from 'react-router-dom';
import Foot2 from '../Foot2/Foot2';
import TopBar from '../TopBar/TopBar';
import Spinner from '../Spinner/Spinner';

function NewPage({ props }) {

  const { id } = useParams();
   
  const [pagedata, setPagedata] = useState([])

     const [loading, setLoading] = useState(true)




  const getPagenews = async () => {
    setLoading(true)
    const response = await fetch(`https://nairalandclone.herokuapp.com/newpage/${id}`);
    const datum = await response.json()
    setPagedata(datum)
    setLoading(false)
   }

  useEffect(() => {
    getPagenews()
  },[])
  
  console.log(pagedata)

  return (
    <>
        <TopBar />
      <div className='newpage'>
        <div className="top">
          <div className="head">Featured News</div>
          <div className="breadcrumbs"><Link to="/" >Nairaland Forum</Link> / <Link to="/"> Featured News & Discussions</Link></div>
          <div className="pages">
            <Link to="/"> (1) </Link> &nbsp;<Link  to="/newpage/2"> (2) </Link>  &nbsp; <Link  to="/newpage/3"> (3) </Link>  &nbsp; <Link  to="/newpage/4"> (4) </Link>  &nbsp; <Link  to="/newpage/5"> (5) </Link>  &nbsp; <Link  to="/newpage/6"> (6) </Link>  &nbsp; <Link  to="/newpage/7"> (7) </Link>  &nbsp; <Link  to="/newpage/8"> (8) </Link>  &nbsp; <Link  to="/newpage/9"> (9) </Link>  &nbsp; <Link  to="/newpage/10"> (10) </Link> 
          </div>
        

        </div>

          <div className="midnews">
           { loading ? <div className="spinn"><Spinner /></div>  :
          pagedata.map(data => {const UrlEncode = encodeURIComponent(data.url); return (<div>&#8811; <Link to={`/open/${UrlEncode}`} className='newtopics' href={data.url} dangerouslySetInnerHTML={{__html: data.title }}/> &#8810;</div>)} )
        }
          </div>
          <div className="pages">
            <Link to="/"> (1) </Link> &nbsp;<Link  to="/newpage/2"> (2) </Link>  &nbsp; <Link  to="/newpage/3"> (3) </Link>  &nbsp; <Link  to="/newpage/4"> (4) </Link>  &nbsp; <Link  to="/newpage/5"> (5) </Link>  &nbsp; <Link  to="/newpage/6"> (6) </Link>  &nbsp; <Link  to="/newpage/7"> (7) </Link>  &nbsp; <Link  to="/newpage/8"> (8) </Link>  &nbsp; <Link  to="/newpage/9"> (9) </Link>  &nbsp; <Link  to="/newpage/10"> (10) </Link> 
          </div>
          <div className="go pages"><Link className='goup' to="/">(Go Up)</Link> <Foot2 /></div>
      </div>
     
    </>

  )
}

export default NewPage